export default __webpack_public_path__ + "static/SuisseIntl-Thin-ab1260f3104532d53f3d77a337d7d615.woff";